import scrollPartiallyVisibleMenuItemIntoView from "@ihs-widget/components/StatsConsole/Layout/StandardAndExpandedStatsConsole/hooks/scrollPartiallyVisibleMenuItemIntoView";
import { useTheme } from "@ihs-widget/stores/useTheme";
import { useLanguage } from "@ihs-widget/utils/hooks/useLanguage";
import { useTranslations } from "../../../../translation/TranslationContext";
import { useMemo } from "react";
import { T, Version } from "@ihs-widget/utils/enums";
import { useVersion } from "@ihs-widget/utils/hooks/useVersion";
import { trackInteraction, mapTitleKeyToElementName } from "@ihs-widget/utils/tracking";

interface MainMenuButtonProps {
    titleKey: string;
    onClick: any;
    isActive: string;
    isDisabled?: boolean;
    elementOrder?: number;
}

const MainMenuButton = ({ titleKey, onClick, isActive, isDisabled = false, elementOrder }: MainMenuButtonProps) => {
    const { theme, version } = useTheme();
    const language = useLanguage();
    const translations = useTranslations(language);
    const { isV1 } = useVersion();

    const title = useMemo(() => {
        const t = translations[titleKey as keyof typeof translations] as unknown as string;
        return typeof t === 'string' ? t : '';
    }, [translations, titleKey]);

    const handleClick = () => {
        if (isDisabled) return;
        trackInteraction({
            interaction_name: 'tab_clicked',
            element_name: mapTitleKeyToElementName(titleKey),
            element_order: elementOrder
        });
        onClick(titleKey);
        scrollPartiallyVisibleMenuItemIntoView(titleKey);
    };

    return (
        <div className='h-full' data-menu-item={titleKey} >
            <div
                data-testid={`stats-console-main-menu-button-${titleKey.toLowerCase()}`}
                className={`leading-[16px] font-medium font-robotoMedium text-[12px] whitespace-nowrap
                            ${isDisabled
                        ? 'opacity-50 cursor-not-allowed'
                        : 'cursor-pointer'
                    }
                            ${isV1 ? 'pt-[8px] pb-[4px] px-[8px] h-[28px] bg-monoY dark:bg-base110'
                        : 'pt-[6px] pb-[2px] px-[8px] h-[24px] dark:bg-[#222222] bg-monoY'}
                            `}
                onClick={handleClick}
                style={{
                    color: theme === T.DARK
                        ? (isActive === titleKey ? "#FFFFFF" : "#CCCCCC")
                        : (isActive === titleKey ? "#111111" : "#6B6B6B"),
                    opacity: isDisabled ? 0.5 : 1
                }}
            >
                {title}
            </div>
            <div className='w-full flex justify-center items-center'>
                <div className={`  ${isV1 ? 'h-[3px] w-full' : 'h-[4px] w-[calc(100%-14px)] flex'}`}
                    style={{ backgroundColor: theme === T.DARK ? (isActive === titleKey ? (isV1 ? "#FFEF6E" : "#4BB68F") : "transparent") : (isActive === titleKey ? (isV1 ? "#F0CD0E" : "#126C57") : "transparent") }}
                />
            </div>
        </div>
    )
}

export default MainMenuButton;